import { Button } from '@material-ui/core';
import { PlayCircleOutline } from '@material-ui/icons';
import React, { useState } from 'react';
import Period from './Period';
import Quotes from './Quotes';
import SliderContainer from './SliderContainer';
import TestSlider from './TestSlider';

function ButtonToStartTimer({ period, setPeriod }) {
  const [play, setPlay] = useState(false);

  return (
    <center>
      {!play && (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setPlay(true)}
        >
          <PlayCircleOutline /> Begin Pomodoro Timer
        </Button>
      )}
      {play && (
        <>
          <SliderContainer period={period} setPeriod={setPeriod} />
          <Quotes />
          {/* <Period /> */}
        </>
      )}
    </center>
  );
}

export default ButtonToStartTimer;
